import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import clsx from "clsx";
import type { ReactElement } from "react";

interface TooltipProps {
	children: ReactElement;
	content: ReactElement | string;
	[key: string]: unknown;
	className?: string | undefined;
}

function Tooltip({ children, className, content, ...props }: TooltipProps) {
	return (
		<TooltipPrimitive.Provider delayDuration={0} skipDelayDuration={500}>
			<TooltipPrimitive.Root>
				<TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
				<TooltipPrimitive.Portal>
					<TooltipPrimitive.Content
						className={clsx(
							"z-10 max-w-[320px] select-none rounded-[4px] bg-background py-1 px-2 shadow-sm shadow-slate-200/30 border border-b-none border-border/30 text-sm font-semibold text-foreground will-change-[transform,opacity]",
							"data-[state=delayed-open]:data-[side=top]:animate-tooltipSlideDownAndFade",
							"data-[state=delayed-open]:data-[side=right]:animate-tooltipSlideLeftAndFade",
							"data-[state=delayed-open]:data-[side=left]:animate-tooltipSlideRightAndFade ",
							"data-[state=delayed-open]:data-[side=bottom]:animate-tooltipSlideUpAndFade",
							className,
						)}
						side="top"
						align="center"
						sideOffset={8}
						{...props}
					>
						{content}
					</TooltipPrimitive.Content>
				</TooltipPrimitive.Portal>
			</TooltipPrimitive.Root>
		</TooltipPrimitive.Provider>
	);
}

export default Tooltip;
